<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="知识点">
                  <el-input  v-model="queryForm.knowledgeName"></el-input>
              </el-form-item>
              <el-form-item label="父级知识点">
                  <el-input  v-model="queryForm.parentId"></el-input>
              </el-form-item>
              <el-form-item label="排序">
                  <el-input  v-model="queryForm.sort"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduKnowledgeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduKnowledge"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduKnowledge(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduKnowledge(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
<!--            <el-upload v-if="this.isImportDate"-->
<!--              class="upload-demo"-->
<!--              action="#"-->
<!--                            :http-request="upload"-->
<!--              :show-file-list="true">-->
<!--              <el-button size="small" type="primary">点击上传</el-button>-->
<!--              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>-->
<!--            </el-upload>-->
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduKnowledgeList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduKnowledgeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduKnowledgeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="knowledgeName"
        label="知识点"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="parentId"
        label="父级知识点"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduKnowledge(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduKnowledge(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduKnowledge(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
              <div @click="addChildCourseCategory(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">添加下级分类</span>
              </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
<!--    <div class="pagination-box">-->
<!--      <el-pagination-->
<!--        @size-change="sizeChange"-->
<!--        @current-change="currentChange"-->
<!--        :current-page.sync="currentPage"-->
<!--        :page-sizes="[10, 20, 50, 100]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="totalNum"-->
<!--        background-->
<!--        :pager-count="7"-->
<!--      >-->
<!--      </el-pagination>-->
<!--    </div>-->
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduKnowledgeStates[eduKnowledgeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduKnowledge"
          ref="eduKnowledgeForm"
          :rules="rules"
          label-width="90px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="知识点"
            prop="knowledgeName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduKnowledge.knowledgeName"
              :disabled="eduKnowledgeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="父级知识点"
            prop="parentId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduKnowledge.parentId"-->
<!--              :disabled="eduKnowledgeState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  :disabled="eduKnowledgeState == 'check'"
                  v-model="eduKnowledge.parentId"
                  placeholder="请选择"
                  size="small"
              >
                  <el-tree
                      :data="eduKnowledgeList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
            <el-form-item
                label="所属科目"
                prop="subjectId"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              v-model="eduKnowledge.parentId"-->
                <!--              :disabled="eduKnowledgeState == 'check'"-->
                <!--            ></el-input>-->
                <el-select
                    clearable
                    style="width: 177px"
                    :disabled="eduKnowledgeState == 'check'"
                    v-model="eduKnowledge.subjectId"
                    placeholder="请选择"
                    size="small"
                >
                    <el-tree
                        :data="eduSubjectList"
                        :props="treeProps1"
                        :render-after-expand="false"
                    >
                        <div
                            class="custom-tree-node flex items-center"
                            slot-scope="{ node, data }"
                        >
                            <el-option
                                :label="node.label"
                                :value="data.id"
                            > </el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduKnowledge.sort"-->
<!--              :disabled="eduKnowledgeState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduKnowledgeState == 'check'"
                  v-model="eduKnowledge.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduKnowledgeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduKnowledgeList();
                    this.getEduKnowledgeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduKnowledgeList();
                    this.getEduKnowledgeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     knowledgeName: '', //知识点
                     parentId: '', //父ID
                     sort: '', //排序
                     subjectId: '',
                },
                treeProps: {
                    children: 'children',
                    label: 'knowledgeName'
                },
                eduSubjectList: [],
                treeProps1: {
                    children: 'children',
                    label: 'subjectName'
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 1,
                currentUserId: '',
                eduKnowledgeState: 'add',
                eduKnowledgeStates: {
                    add: '新建知识点',
                    check: '查看知识点',
                    edit: '修改知识点'
                },

                multipleSelection: [],
                eduKnowledgeList: [],
                eduKnowledge: {
                    id: '', //
                    knowledgeName: '', //知识点
                    parentId: '', //父ID
                    sort: '', //排序
                    subjectId: '',
                },
                btnLoading: false,

                rules: {
                    knowledgeName: [{ required: true, message: '知识点不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    subjectId: [{ required: true, message: '所属科目不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {
            this.getEduKnowledgeList();
            this.getSubject();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetEduKnowledgeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduKnowledgeList = [];
            },
            addChildCourseCategory(id){
                this.addEduKnowledge()
                this.eduKnowledge.parentId = id
            },
            getSubject(){
                get('/edu/subject/findAllAsTree').then((res)=>{
                    if(res.success){
                        this.eduSubjectList = res.treeData
                    }
                })
            },
            resetDialog() {
                this.eduKnowledgeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      knowledgeName: '', //知识点
                      parentId: '', //父ID
                      sort: '', //排序
                };
                this.getEduKnowledgeList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduKnowledge = {
                      id: '', //
                      knowledgeName: '', //知识点
                      parentId: '', //父ID
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduKnowledgeState == 'add') {
                    this.$refs.eduKnowledgeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/knowledge/add`,{ ...this.eduKnowledge }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduKnowledgeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduKnowledgeState == 'edit') {
                    this.$refs.eduKnowledgeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduKnowledge.children;
                            post(`/edu/knowledge/edit`,{ ...this.eduKnowledge }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduKnowledgeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduKnowledge() {
                this.showDialog = true;
                this.eduKnowledgeState = 'add';
            },
            checkEduKnowledge(eduKnowledgeId) {
                console.log(eduKnowledgeId);
                this.currentEduKnowledgeId = eduKnowledgeId;

                this.getEduKnowledgeById();
                this.showDialog = true;
                this.eduKnowledgeState = 'check';
            },
            editEduKnowledge(eduKnowledgeId) {
                console.log('eduKnowledge', eduKnowledgeId);
                if (eduKnowledgeId) {
                    this.currentEduKnowledgeId = eduKnowledgeId;
                    this.getEduKnowledgeById();
                } else {
                    this.eduKnowledge = { ...this.eduKnowledge, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduKnowledgeState = 'edit';
            },
            deleteEduKnowledge(eduKnowledgeId) {
                let ids = '';
                if (eduKnowledgeId) {
                    ids = eduKnowledgeId;
                } else {
                    ids = this.multipleSelection.map((eduKnowledge) => eduKnowledge.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/knowledge/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduKnowledgeList();
                                this.getEduKnowledgeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduKnowledgeList() {
                this.resetEduKnowledgeList();
                this.getEduKnowledgeList();
            },
            getEduKnowledgeList(query = {}) {
                this.loading = true;
                get(`/edu/knowledge/findAllAsTree`,{  ...this.queryForm }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduKnowledgeList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduKnowledgeById() {
                get(`/edu/knowledge/get`,{ id: this.currentEduKnowledgeId }).then((res) =>{
                    if(res.success){
                      this.eduKnowledge = { ...this.eduKnowledge, ...res.eduKnowledge };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduKnowledgeList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/knowledge/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/knowledge/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/knowledge/importData`,formData);
              this.refreshEduKnowledgeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduKnowledgeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduKnowledgeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>